import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PhotoDetail from "@/pages/PhotoDetail";
import UploadPage from "@/pages/UploadPage";
import Profile from "@/pages/Profile";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";
import HubList from "@/pages/HubList";
import HubDetail from "@/pages/HubDetail";
import CategoryIndex from "@/pages/CategoryIndex";
import CategoryDetail from "@/pages/CategoryDetail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BulkCategorize from "@/pages/BulkCategorize";
import Duplicates from "@/pages/Duplicates";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/photo/:id" element={<PhotoDetail />} />
                <Route path="/profile/:id" element={<Profile />} />
                <Route path="/p/:slug" element={<Profile />} />
                <Route path="/c" element={<HubList />} />
                <Route path="/c/:slug" element={<HubDetail />} />
                <Route path="/categories" element={<CategoryIndex />} />
                <Route path="/category/:slug" element={<CategoryDetail />} />
                <Route path="/upgrade" element={<Upgrade />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route
                  path="/organize/genres"
                  element={<ProtectedRoute><BulkCategorize /></ProtectedRoute>}
                />
                <Route
                  path="/organize/duplicates"
                  element={<ProtectedRoute><Duplicates /></ProtectedRoute>}
                />
                <Route
                  path="/upload"
                  element={
                    <ProtectedRoute>
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <footer className="border-t border-zinc-900 mt-20">
              <div className="mx-auto max-w-[1600px] px-6 sm:px-10 py-10 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                <div>Social Gallery · Galería Social</div>
                <div>© {new Date().getFullYear()} · All frames by their authors.</div>
              </div>
            </footer>
          </div>
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
